<template>
  <section class="career-application">

    <div class="career-application__inner" v-if="successfully_saved">
      <h2 class="career-application__success-title">Thank you for applying!</h2>
      <p class="career-application__success-text">We have received your application and will be in touch shortly.</p>
    </div>

    <form v-else class="career-application__inner" @submit.stop.prevent="careerApplication__submitted" enctype="multipart/form-data">

      <h2 class="career-application__heading">Apply for this role</h2>

      <fieldset class="career-application__row">
        <label class="career-application__label">Title</label>
        <div class="career-application__field">
          <select class="career-application__select" v-model="application.title" @change="clearErrors">
            <option value="">- please select -</option>
            <option v-for="option in title_options" :key="option" :value="option">{{ option }}</option>
          </select>
        </div>
      </fieldset>

      <fieldset class="career-application__row">
        <label class="career-application__label">First Name</label>
        <div class="career-application__field">
          <input class="career-application__input" type="text" v-model="application.first_name" placeholder="First Name" @change="clearErrors" />
        </div>
      </fieldset>

      <fieldset class="career-application__row">
        <label class="career-application__label">Last Name</label>
        <div class="career-application__field">
          <input class="career-application__input" type="text" v-model="application.last_name" placeholder="Last Name" @change="clearErrors" />
        </div>
      </fieldset>

      <fieldset class="career-application__row">
        <label class="career-application__label">Email Address</label>
        <div class="career-application__field">
          <input class="career-application__input" type="email" v-model="application.email" placeholder="Email Address" @change="clearErrors" />
        </div>
      </fieldset>

      <fieldset class="career-application__row">
        <label class="career-application__label">Phone</label>
        <div class="career-application__field">
          <input class="career-application__input" type="text" v-model="application.phone" placeholder="Phone" @change="clearErrors" />
        </div>
      </fieldset>

      <fieldset class="career-application__row">
        <label class="career-application__label">Date of Birth</label>
        <div class="career-application__field">
          <input class="career-application__input" type="date" v-model="application.date_of_birth" @change="clearErrors" />
        </div>
      </fieldset>

      <h2 class="career-application__heading">Additional Information</h2>

      <fieldset class="career-application__row">
        <label class="career-application__label">Address</label>
        <div class="career-application__field">
          <input class="career-application__input" type="text" v-model="application.address" placeholder="Address" @change="clearErrors" />
        </div>
      </fieldset>

      <fieldset class="career-application__row">
        <label class="career-application__label">Suburb</label>
        <div class="career-application__field">
          <input class="career-application__input" type="text" v-model="application.suburb" placeholder="Suburb" @change="clearErrors" />
        </div>
      </fieldset>

      <fieldset class="career-application__row">
        <label class="career-application__label">State</label>
        <div class="career-application__field">
          <input class="career-application__input" type="text" v-model="application.state" placeholder="State" @change="clearErrors" />
        </div>
      </fieldset>

      <fieldset class="career-application__row">
        <label class="career-application__label">Postcode</label>
        <div class="career-application__field">
          <input class="career-application__input" type="text" v-model="application.postcode" placeholder="Postcode" @change="clearErrors" />
        </div>
      </fieldset>

      <fieldset class="career-application__row">
        <label class="career-application__label">Country</label>
        <div class="career-application__field">
          <input class="career-application__input" type="text" v-model="application.country" placeholder="Country" @change="clearErrors" />
        </div>
      </fieldset>

      <h2 class="career-application__heading">JOB INFORMATION</h2>

      <fieldset class="career-application__row">
        <label class="career-application__label">Interested in:</label>
        <div class="career-application__field">
          <input class="career-application__input" type="text" :value="career ? career.title : ''" disabled />
        </div>
      </fieldset>

      <fieldset class="career-application__row">
        <label class="career-application__label">State:</label>
        <div class="career-application__field">
          <input class="career-application__input" type="text" :value="career_state_label" disabled />
        </div>
      </fieldset>

      <fieldset class="career-application__row">
        <label class="career-application__label">Location:</label>
        <div class="career-application__field">
          <input class="career-application__input" type="text" :value="career ? career.suburb : ''" disabled />
        </div>
      </fieldset>

      <fieldset class="career-application__row">
        <label class="career-application__label">Vacancy Type</label>
        <div class="career-application__field">
          <div class="career-application__check-group" v-for="option in vacancy_type_options" :key="option">
            <input :id="`vacancy-${option}`" type="checkbox" :value="option" v-model="application.vacancy_types" />
            <label :for="`vacancy-${option}`">{{ option }}</label>
          </div>
        </div>
      </fieldset>

      <fieldset class="career-application__row">
        <label class="career-application__label">CV Upload (doc, docx, pdf, rtf, txt files only)</label>
        <div class="career-application__field">
          <input class="career-application__file" type="file" accept=".doc,.docx,.pdf,.rtf,.txt" @change="cv__changed" />
        </div>
      </fieldset>

      <fieldset class="career-application__row">
        <label class="career-application__label">Any comments on your previous experience?</label>
        <div class="career-application__field">
          <textarea class="career-application__textarea" rows="5" v-model="application.comment" @input="clearErrors"></textarea>
        </div>
      </fieldset>

      <fieldset class="career-application__row">
        <label class="career-application__label">How did you hear about Just Cuts?</label>
        <div class="career-application__field">
          <select class="career-application__select" v-model="application.source" @change="clearErrors">
            <option value="">- please select -</option>
            <option v-for="option in source_options" :key="option" :value="option">{{ option }}</option>
          </select>
        </div>
      </fieldset>

      <fieldset class="career-application__row" v-if="application.source === 'Others, please state'">
        <label class="career-application__label">Other</label>
        <div class="career-application__field">
          <input class="career-application__input" type="text" v-model="application.other_source" placeholder="Other" @change="clearErrors" />
        </div>
      </fieldset>

      <fieldset class="career-application__row career-application__row--checks">
        <div class="career-application__field career-application__field--full">
          <div class="career-application__check-group">
            <input id="career-application-news" type="checkbox" v-model="application.send_news" />
            <label for="career-application-news">Send ongoing information regarding Just Cuts franchise opportunities and news.</label>
          </div>
          <div class="career-application__check-group">
            <input id="career-application-other-positions" type="checkbox" v-model="application.contact_other_positions" />
            <label for="career-application-other-positions">Contact regarding other positions</label>
          </div>
          <div class="career-application__check-group" v-if="career_state_abbreviation">
            <input id="career-application-job-alerts" type="checkbox" v-model="application.register_job_alerts" />
            <label for="career-application-job-alerts">Register for {{ career_state_abbreviation }} Job Alerts</label>
          </div>
        </div>
      </fieldset>

      <fieldset class="career-application__row career-application__row--actions">
        <div class="career-application__field career-application__field--full">
          <button type="submit" class="career-application__submit" :class="{ 'career-application__submit--error': error_message.length > 0 }" :disabled="is_submitting">{{ is_submitting ? 'Submitting…' : 'Submit' }}</button>
          <div class="career-application__error" v-if="error_message.length > 0">{{ error_message }}</div>
        </div>
      </fieldset>

      <p class="career-application__disclaimer">
        <b>Disclaimer:</b>
        We will keep your personal details on file and may contact you with any positions which are available and suitable. We do not share data with third parties.
        If you wish to be contacted by Just Cuts, please tick the box.
      </p>

    </form>
  </section>
</template>


<script>

import CareerApplication from "../../models/CareerApplication";
import Api from "../../services/api";

export default {
  props:{
    career: { type: Object, default: null }
  },
  data(){
    return {
      successfully_saved: false,
      is_submitting: false,
      cv_file: null,
      application: CareerApplication.newDefault(),
      title_options: ['Mr', 'Mrs', 'Miss', 'Ms', 'Other'],
      vacancy_type_options: ['Full Time', 'Part Time', 'Casual'],
      source_options: ['Just Cuts Salon', 'Search Engine eg. Google', 'Magazine Advert', 'Television Advert', 'Website', 'Word of Mouth', 'Others, please state', 'Radio'],
      error_message: ""
    }
  },
  computed:{
    career_state_label(){
      if(!this.career) return "";
      return [this.career.country_name, this.career.state_abbreviation].filter(p => p && p.length > 0).join(" - ");
    },
    career_state_abbreviation(){
      return this.career && this.career.state_abbreviation ? this.career.state_abbreviation : "";
    }
  },
  methods:{
    cv__changed(event){
      this.cv_file = event.target.files && event.target.files.length > 0 ? event.target.files[0] : null;
      this.clearErrors();
    },
    clearErrors(){
      this.error_message = "";
    },
    isFormValid(){
      this.error_message = "";
      if(this.application.first_name.length < 2){ this.error_message = "Please provide a first name."; }
      else if(this.application.last_name.length < 2){ this.error_message = "Please provide a last name."; }
      else if(this.application.email.length < 5 || !this.application.email.includes("@")){ this.error_message = "Please provide a valid email address."; }
      else if(this.application.phone.length < 6){ this.error_message = "Please provide a valid phone number."; }
      else if(this.application.vacancy_types.length < 1){ this.error_message = "Please select at least one vacancy type."; }
      else if(this.application.source === 'Others, please state' && this.application.other_source.length < 1){ this.error_message = "Please describe how you heard about us."; }
      return this.error_message.length < 1;
    },
    async careerApplication__submitted(){
      if(this.is_submitting) return;
      try {
        if(!this.isFormValid()) return;

        this.is_submitting = true;

        if(this.career && this.career.id){
          this.application.career_id = this.career.id;
        }

        if(this.cv_file){
          this.application.cv_url = await CareerApplication.uploadCV(this.cv_file);
        }

        await this.application.create();
        this.successfully_saved = true;
        const match = this.application.id ? { id: this.application.id } : { email: this.application.email };
        Api.sendNotification('career_application', match).catch(error => console.error("notification dispatch failed", error));
      } catch(error){
        alert(error.message);
      } finally {
        this.is_submitting = false;
      }
    }
  }
}
</script>
